import React, { createContext, useReducer } from "react";
import { namePositionReducer } from "../reducers/namePositionReducer";

export const NamePositionContext = createContext();

const NamePositionContextProvider = (props) => {
  const [info, dispatch] = useReducer(
    namePositionReducer, {
        name: '',
        position: ''
    }
  );
  return (
    <NamePositionContext.Provider value={{ info, dispatch }}>
      {props.children}
    </NamePositionContext.Provider>
  );
};

export default NamePositionContextProvider;
